import axios from 'axios';

export const moduleTrainingList = {
	state() {
		return {
			trainingList: null,
			displayRegistrationModal: false,
			registrationSuccess: true,
			//Loader
			trainingListLoader: false,
		};
	},
	mutations: {
		setTrainingList(state, data) {
			state.trainingList = data;
		},
		setDisplayRegistrationModal(state, data) {
			state.displayRegistrationModal = data;
		},
		setRegistrationSuccess(state, data) {
			state.registrationSuccess = data;
		},
		// Loader
		setTrainingListLoader(state, data) {
			state.trainingListLoader = data;
		},
	},
	getters: {
		getTrainingList: (state) => state.trainingList,
		getDisplayRegistrationModal: (state) => state.displayRegistrationModal,
		getRegistrationSuccess: (state) => state.registrationSuccess,
		// Loader
		getTrainingListLoader: (state) => state.trainingListLoader,
	},
	actions: {
		fetchTrainingList({ commit, dispatch }) {
			commit('setTrainingListLoader', true);
			var obj = {
				Top: 50,
			};
			dispatch('newLogoutTime');
			axios
				.post('Training/GetList', obj)
				.then((response) => {
					commit('setTrainingList', response.data);
					return;
				})
				.catch(() => {})
				.finally(() => {
					commit('setTrainingListLoader', false);
				});
		},
		postTrainingRegistration({ commit, dispatch }, trainingId) {
			var obj = {
				trainingId: trainingId,
			};
			dispatch('newLogoutTime');
			axios
				.post('Training/Registration', obj)
				.then(
					() => {
						commit(
							'setGlobalSuccessMessage',
							'Rejestracja przebiegła pomyślnie. Dziękujemy i zapraszamy do udziału.'
						);
						dispatch('fetchTrainingList');
					},
					() => {
						commit(
							'setGlobalErrorMessage',
							'Niestety, rejestracja nie została wykonana prawidłowo. Prosimy o kontakt w celu wyjaśnienia problemu.'
						);
					}
				)
				.then(() => {
					window.scroll({
						top: 0,
						left: 0,
						behavior: 'smooth',
					});
				});
		},
	},
};
